import { render, staticRenderFns } from "./MultiFile.vue?vue&type=template&id=52f7c2df&scoped=true&"
import script from "./MultiFile.vue?vue&type=script&lang=js&"
export * from "./MultiFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7c2df",
  null
  
)

export default component.exports